import React, { useState } from 'react';
import { Modal } from "react-bootstrap";
import { getFilteredBill } from "../../helpers/help";

const OrderDetails = (props) => {
    const { openOrderDetailsModal, setOpenOrderDetailsLogoutModal, selectedIndexItem } = props;

    return (
        <Modal
            show={openOrderDetailsModal}
            onHide={() => setOpenOrderDetailsLogoutModal(false)}
            centered
            className="logoutmodal center-close-icon"
        >
            <Modal.Header closeButton></Modal.Header>
            <div className="bodyModal">
                <h5 className="head5 text-break" >{selectedIndexItem?.displayOrderId}</h5>
                <p
                    className='txt'
                >
                    {selectedIndexItem.displayTotalItems}, To pay:{" "}


                    <span className='txtinred'>{selectedIndexItem?.displayNetAmount ? selectedIndexItem.displayNetAmount.charAt(0) + Number(selectedIndexItem?.displayNetAmount.split("$")[1]).toFixed(2) : selectedIndexItem?.displayNetAmount}</span></p>
                <hr className='my-3' />
                <div className="d-flex align-items-baseline">
                    <div className="locImg me-2"><img src="./assets/img/location_pro.svg" alt="ordercard" /></div>
                    <div>
                        <h6 className='head6 mb-0 text-break'>{selectedIndexItem?.outletName}</h6>
                        <p className='txt mb-0 text-break'>{selectedIndexItem?.outletAddress}</p>
                    </div>
                </div>
                <hr className='my-3' />

                {
                    selectedIndexItem && Array.isArray(selectedIndexItem.dishes) && selectedIndexItem.dishes.map((dishItem) => (
                        <div
                            className="addlist_item"
                        >
                            <div
                                className="d-flex align-items-center justify-content-between mb-1"
                            >
                                <h6 className='head6 mb-0 text-break'>{dishItem?.dishplayDish}</h6>
                                <p className='txt txtinred mb-0 ms-2'>{dishItem.displayPrice ? dishItem.displayPrice.charAt(0) + Number(dishItem.displayPrice.split("$")[1]).toFixed(2) : dishItem.displayPrice}</p>
                            </div>
                            {dishItem.customisationItems.map((dishCustomisationItem) => (
                                <div>
                                    <p className='txt mb-1 text-break'>{dishCustomisationItem?.customizableName}</p>


                                    {dishCustomisationItem.customizableDishItems.map(
                                        (customizableDish) => (
                                            <div
                                            >
                                                <div className="d-flex justify-content-between">
                                                    <p className='txt mb-1 text-break'>{customizableDish?.elementName} <span>{customizableDish.displayPrice ? customizableDish.displayPrice.charAt(0) + Number(customizableDish.displayPrice.split("$")[1]).toFixed(2) : customizableDish.displayPrice}</span></p>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            ))}
                            <hr className='my-3' />

                        </div>
                    ))
                }
                {
                    selectedIndexItem && selectedIndexItem?.charges?.map(
                        (billCategory) =>
                            getFilteredBill(billCategory.displayKey) && (
                                <p
                                    key={`${billCategory.displayKey}-${billCategory.displayValue}`}
                                    className='dargayFor txt mb-1 d-flex align-items-center justify-content-between '
                                >
                                    <span>{billCategory.displayKey}:</span>
                                    <span>{billCategory.displayKey ? billCategory.displayValue.charAt(0) + parseFloat(billCategory.displayValue.replace(/[^\d.-]/g, '')) : billCategory.displayValue}</span>
                                </p>

                            ))}
            </div>



        </Modal>
    );
};
export default OrderDetails;
